<template>
  <ul class="mobile-arti-listcontent">
    <li v-for="item in result.data" :key="item.artiId" @click="handleDetail(item)">
      <div class="content-thumb" v-if="item.imgUrl">
        <img :src="item.imgUrl">
      </div>
      <div class="content-msg" v-if="item.imgUrl">
        <h4 v-text="item.artiName"></h4>
        <div v-text="item.description"></div>
      </div>
      <div class="content-msg-w100" v-else>
        <h4 v-text="item.artiName"></h4>
        <div v-text="item.description"></div>
      </div>
      <div class="content-info">
        <span class="content-info-left" v-text="item.createDate"></span>
        <span class="content-info-mid" v-text="item.createUserId"></span>
        <span class="content-info-right">
          <img src="../../assets/mobile/yidu@2x.png">
          {{item.showNum}}已读
        </span>
      </div>
    </li>
  </ul>
</template>
<script>
require("../../styles/mobile/mobile-arti-page-content.scss");
export default {
  name: "mobile-arti-page-content",
  data() {
    return {};
  },
  props: {
    result: {
      type: Object
    }
  },
  mounted() {},
  components: {},
  methods: {
    handleDetail(item) {
      let _module = "article";
      let _field ="";
      if(item.typeId==="d60bdaa3-1866-4adf-ace8-e2d23101fc1d") {
        let url = "http://image.cache.timepack.cn/nodejs.pdf";
        window.open(
          `${
            this.$app.url.cdn
          }/plugins/pdfplayer/2017/web/viewer.html?file=${url}`
        );
      } else {
        if(item.typeId==="b32e151b-9869-4691-8cda-62d38c98dac3")
        {
            _field ="bhjs";
        }
        else if(item.typeId==="b32e151b-9869-4691-8cda-62d38c98dac3")
        {
            _field ="yjcg";
        }
        else{
           _field ="mwsh";
        }
        this.$router.push({
          path: `/mobile/arti/detail/${_module}/${_field}_detail/${item.artiId}`
        });
      }
    }
  },
  computed: {}
};
</script>
